import { render } from "./selectArrow.svg?vue&type=template&id=58282d94"
const script = {}

import exportComponent from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/baidu-tic/psychological-evaluation/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__